import { useRefs, useEvent } from '../framework'
import { events } from './../events'

export default ref => {
  if (!ref.leftMenuLg) return

  let refs = useRefs({ target: ref.leftMenuLg[0], asArray: true })

  function closeAll({ except } = {}) {
    if (!except) refs.root?.classList.remove('open')

    refs.triggers?.map(trigger => {
      if (trigger === except) return
      trigger.parentElement.querySelector('ul')?.classList.remove('open')
    })
  }

  refs.triggers?.map(trigger => {
    trigger.addEventListener('mouseenter', () => {
      if (ref.header[0].classList.contains('is-transitioning')) return

      closeAll({ except: trigger })
      trigger.parentElement.querySelector('ul')?.classList.add('open')
      refs.root.classList.add('open')

      useEvent.dispatch(events.menu.toggled, { menu: 'left', open: true })
    })
  })

  refs.closeTrigger?.map(trigger => {
    trigger.addEventListener('mouseenter', () => {
      if (ref.header && ref.header[0].classList.contains('is-transitioning')) return

      closeAll() // Calling this without "except" removes the "open" class entirely
      useEvent.dispatch(events.menu.toggled, { menu: 'left', open: false })
    })
  })

  function handleClose({ detail }) {
    if (detail?.menu === 'left' || detail?.open) return
    closeAll()
  }

  useEvent.listen(events.blur.hovered, () => closeAll(), { global: true })
  useEvent.listen(events.key.esc, () => closeAll(), { global: true })
  useEvent.listen(events.menu.toggled, handleClose, { global: true })

  return () => (refs = null)
}
